import { render, staticRenderFns } from "./cart-superuser-change-price.vue?vue&type=template&id=9b32124c&"
import script from "./cart-superuser-change-price.vue?vue&type=script&lang=js&"
export * from "./cart-superuser-change-price.vue?vue&type=script&lang=js&"
import style0 from "./cart-superuser-change-price.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports